import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BASE_URL = "https://www.translateloo.com";

interface SEOProps {
    title?: string;
    description?: string;
}

/**
 * SEO component that sets the canonical URL and meta tags for each page.
 * The canonical URL is automatically generated based on the current route.
 */
export function SEO({ title, description }: SEOProps) {
    const location = useLocation();

    useEffect(() => {
        // Build canonical URL from current path
        const canonicalPath = location.pathname === "/" ? "" : location.pathname;
        const canonicalUrl = `${BASE_URL}${canonicalPath}`;

        // Update or create canonical link
        let canonicalLink = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
        if (!canonicalLink) {
            canonicalLink = document.createElement("link");
            canonicalLink.rel = "canonical";
            document.head.appendChild(canonicalLink);
        }
        canonicalLink.href = canonicalUrl;

        // Update OG URL
        let ogUrl = document.querySelector('meta[property="og:url"]') as HTMLMetaElement;
        if (!ogUrl) {
            ogUrl = document.createElement("meta");
            ogUrl.setAttribute("property", "og:url");
            document.head.appendChild(ogUrl);
        }
        ogUrl.content = canonicalUrl;

        // Update title if provided
        if (title) {
            document.title = title;

            const ogTitle = document.querySelector('meta[property="og:title"]') as HTMLMetaElement;
            if (ogTitle) {
                ogTitle.content = title;
            }
        }

        // Update description if provided
        if (description) {
            const metaDesc = document.querySelector('meta[name="description"]') as HTMLMetaElement;
            if (metaDesc) {
                metaDesc.content = description;
            }

            const ogDesc = document.querySelector('meta[property="og:description"]') as HTMLMetaElement;
            if (ogDesc) {
                ogDesc.content = description;
            }
        }
    }, [location.pathname, title, description]);

    return null;
}
